var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bow-page bow-single-immobile"},[_c('client-only',[_c('BowHeader')],1),_vm._v(" "),_c('BowLocomotiveScroll',{attrs:{"sections":_vm.sections,"parallax":{
            active: true,
            top: '30%',
        }}}),_vm._v(" "),(_vm.checkBreakpointUpXl)?_c('BowFooter',{attrs:{"isDesktop":true}}):_vm._e(),_vm._v(" "),_c('BowSliderFull')],1)}
var staticRenderFns = []

export { render, staticRenderFns }